"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountMenuWrapper = void 0;
const styles_1 = require("@mui/material/styles");
exports.AccountMenuWrapper = (0, styles_1.styled)("div")(() => ({
    display: "flex",
    alignItems: "center",
}));
